import React from 'react';
import { throttle } from "lodash";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export default class HfKendoComboBox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filter: "",
            internalValue: null,
            initData: [],
            currentData: [],
            isLoading: false,
            noDataMessage: ""
        };

        this.handleFilterChange = throttle(this.handleFilterChange, this.props.delay);
    }

    componentDidMount() {
        if (this.props.loadOnInit) {
            this.setState({
                isLoading: true
            });

            this.props.api().then((data) => {
                this.setState({
                    initData: data,
                    currentData: data,
                    isLoading: false
                });
            });
        }
    }

    handleChange = (e) => {
        this.props.onChange(e);

        this.setState({
            internalValue: e.value
        });
    }

    handleFilterChange = (event) => {
        this.setState({
            filter: event.filter.value
        });

        if (this.props.minLengthForSearch !== undefined) {
            if (event.filter.value.length < this.props.minLengthForSearch) {
                this.setState({
                    currentData: [],
                    isLoading: false
                });
                return;
            }
        }

        if (this.props.loadOnInit) {
            const filteredData = filterBy(this.state.initData.slice(), event.filter);

            this.setState({
                currentData: filteredData
            });
        } else {
            this.setState({
                isLoading: true
            });

            this.props.api(event.filter.value).then((data) => {
                this.setState({
                    currentData: data,
                    isLoading: false
                });
            });
        }
    }

    handleOpen = (element) => {
        return false;
    }

    listNoDataRender = (element) => {
        let message = "";
        if (this.state.filter.length < this.props.minLengthForSearch) {
            message = `Type at least ${this.props.minLengthForSearch} characters to search`
        } else if (this.state.isLoading) {
            message = "Loading"
        } else {
            message = "No Matches"
        }

        const noData = (
            <h4
                style={{
                    fontSize: "1em",
                }}
            >
                {message}
            </h4>
        );

        return React.cloneElement(element, { ...element.props }, noData);
    };

    reset = () => {
        this.setState({
            internalValue: null
        });
    }

    render() {
        return (
            <ComboBox {...this.props}
                value={this.props.value ?? this.state.internalValue}
                data={this.state.currentData}
                onChange={this.handleChange}
                filterable={true}
                loading={this.state.isLoading}
                onFilterChange={this.handleFilterChange}
                listNoDataRender={this.listNoDataRender}
                onOpen={this.handleOpen}
            />
        );
    }
}